// extracted by mini-css-extract-plugin
export default {"annImage":"Annotation_annImage__6D5Oh","annContainer":"Annotation_annContainer__ug72v","metaBlockContainer":"Annotation_metaBlockContainer__697nR"};